<style lang="scss" scoped>
.fix {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 100;
  &.white-bg {
    background-color: #fff;
  }

  .iconfont {
    width: 56px;
    height: 56px;
    font-size: 56px;
    line-height: 56px;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 100%;
  }

  .header-content {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 88px;
    padding: 16px 32px;
    .header-back {
      display: flex;
      align-items: flex-end;
      img {
        width: 56px;
        height: 56px;
      }
    }
  }

  .sell {
    margin-right: 20px;
    color: #111111;
    font-weight: 600;
    font-size: 30px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    text-align: center;
  }

  .collect-wrap {
    position: relative;
    width: 56px;
    height: 56px;

    @keyframes collect {
      from {
        transform: scale(0);
      }
      to {
        transform: scale(1);
      }
    }

    .collect {
      width: 100%;
      height: 100%;
    }

    .count {
      position: absolute;
      top: -5px;
      right: -10px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      height: 24px;
      padding: 2px 4px;
      color: #111;
      font-weight: 500;
      font-size: 18px;
      font-family: PingFangHK-Medium, PingFangHK;
      background: #fff;
      border: 3px solid #fff;
      border-radius: 100px;
      &.active {
        color: #fff;
        background: #ff483c;
      }
      &.collected {
        animation: collect 0.5s ease-in-out;
      }
    }
  }

  .rent,
  .collect-wrap {
    margin-right: 20px;
  }

  .header-op {
    display: inline-flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;
    i {
      margin-right: 5px;
    }
    .header-more {
      position: relative;

      .more-badge {
        position: relative;
        display: flex;
        align-items: center;
      }
      .count {
        position: absolute;
        top: -5px;
        right: -10px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        height: 24px;
        padding: 2px 4px;
        color: #111;
        font-weight: 500;
        font-size: 18px;
        font-family: PingFangHK-Medium, PingFangHK;
        background: #fff;
        border: 3px solid #fff;
        border-radius: 100px;
        &.active {
          color: #fff;
          background: #ff483c;
        }
        &.collected {
          animation: collect 0.5s ease-in-out;
        }
      }

      /deep/.z-simple-dropdown__popover {
        right: -8px;
      }
    }
    .cart-badge {
      // margin-right: 36px;
      margin-right: 20px;
    }
    .icon-fenxiang1 {
      // margin-right: 36px;
      margin-right: 20px;
    }
  }

  .service-tip {
    position: absolute;
    right: -14px;
    z-index: 9999999;
    display: flex;
    width: max-content;
    color: #111;
    font-size: 28px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 10px;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.2);
    transition: opacity 0.2s;
    &-angle {
      position: absolute;
      top: -12px;
      right: 10px;
      transform: translateX(-50%);
      &::before {
        display: block;
        border-color: transparent transparent rgba(255, 255, 255, 0.9);
        border-style: solid;
        border-width: 0 14px 14px;
        transform: rotate(0deg);
        content: '';
      }
    }
    &-content {
      flex: 1;
      flex-basis: 0.000000001px;
      min-height: 36px;
      padding: 0 24px;
      line-height: 36px;
      text-align: center;
      &_item {
        box-sizing: border-box;
        width: 164px;
        padding: 15px 0;
        border-bottom: 1px solid #f0f0f0;
      }
    }
  }
}
.search-wrap {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  width: 386px;
  margin: 0 20px 0 16px;
  padding: 0 20px;
  color: #bbbbbb;
  font-weight: 300;
  font-size: 28px;
  font-family: PingFangSC-Light, PingFang SC;
  background: #f7f7f7;
  border-radius: 28px;

  .z-swipe-wrap {
    box-sizing: border-box;
    height: 56px;
    font-size: 28px;
    line-height: 56px;
  }

  .word {
    width: 100%;
    height: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  img {
    width: 32px;
    height: 32px;
    margin-right: 16px;
  }
}

.middle-content {
  flex: 1;
  visibility: hidden;
  &.show {
    visibility: visible;
  }
}
</style>

<template>
  <header
    :class="{ 'white-bg': !transparent }"
    :style="{ 'padding-top': `${statusHeight}px` }"
    class="fix"
  >
    <section v-if="inZZ" v-zpm="{ sectionid: 99 }" class="header-content">
      <div v-zpm="{ sortid: 0, sortname: '返回' }" class="header-back" @click="onBack">
        <img
          :src="
            $setPicSize(
              'https://pic3.zhuanstatic.com/zhuanzh/bb1960bf-8662-4aeb-9393-5458faef5fd0.png',
              56,
              56
            )
          "
          alt=""
        />
      </div>
      <div
        v-if="!state.packageId"
        :class="!getQueryString('saleCombineIds') && 'show'"
        class="middle-content"
      >
        <!-- ab搜素框 -->
        <div
          v-if="!showSwiper && keywordData.length"
          v-zpm="{
            sortid: 5,
            sortname: '商详搜索框',
            areaexposure: 99,
            legoareabackup: {
              sortname: '商详搜索框',
              sortid: 5
            },
            backup: {
              keyword: keywordData[wordActIndex].word
            }
          }"
          class="search-wrap"
          @click="onSearch"
        >
          <img
            :src="
              $setPicSize(
                'https://pic4.zhuanstatic.com/zhuanzh/c44ef7e0-bc34-4541-b74d-fcbbaf86a68d.png',
                64,
                64
              )
            "
            alt=""
          />
          <z-swipe
            class="z-swipe-wrap"
            :autoplay="2500"
            :show-indicators="false"
            :loop="true"
            vertical
            :touchable="false"
            width="100%"
            @change="(i) => (wordActIndex = i)"
          >
            <z-swipe-item v-for="(item, index) in keywordData" :key="item.word + index">
              <div class="word">{{ item.word }}</div>
            </z-swipe-item>
          </z-swipe>
        </div>
        <guide-swiper
          v-if="showSwiper && baseInfoMsg.guideInfoList"
          :guideInfoList="baseInfoMsg.guideInfoList"
        ></guide-swiper>
      </div>

      <div v-if="!getQueryString('saleCombineIds') && !state.packageId" class="header-op">
        <div style="display: flex">
          <!-- 收藏按钮 -->
          <div v-if="baseInfoMsg.sellEntry" class="collect-wrap">
            <img
              v-zpm="{
                sortid: 1,
                sortname: '收藏夹',
                areaexposure: 99,
                legoareabackup: { sortName: '收藏夹' }
              }"
              class="iconfont collect"
              :src="
                $setPicSize(
                  'https://pic4.zhuanstatic.com/zhuanzh/3ca489bd-7c0e-4e53-bda6-4a539708bf8a.png',
                  56,
                  56
                )
              "
              alt=""
              @click="toCollect"
            />
            <div
              v-if="collectAllCount"
              class="count"
              :class="{
                active: activeInfo,
                collected: collectAnimationEnd
              }"
            >
              {{ collectAllCount }}
            </div>
          </div>
        </div>

        <img
          v-if="showRentIcon"
          v-zpm="{ sortid: 3, sortname: '租' }"
          class="iconfont rent"
          :src="
            $setPicSize(
              'https://pic3.zhuanstatic.com/zhuanzh/56adef66-d2ce-49bb-a5da-5c5f2b16fad9.png',
              56,
              56
            )
          "
          alt=""
          @click="toRent"
        />
        <z-platform-share-panel
          pageId="T2974"
          :platforms="platforms"
          :actions="actions"
          @platform-select="onPlatformSelect"
          @action-select="onActionSelect"
        >
          <template #btnMore>
            <span class="header-more">
              <span class="more-badge">
                <img
                  class="iconfont icon-more"
                  src="https://pic3.zhuanstatic.com/zhuanzh/b38eb2d5-3274-4eb8-b4e5-daef7c16c7c6.png"
                  alt=""
                />
                <div
                  v-if="cartedAllCount"
                  class="count"
                  :class="{
                    active: cartStatus,
                    collected: cartAnimationEnd
                  }"
                >
                  {{ cartedAllCount }}
                </div>
              </span>
            </span>
          </template>
        </z-platform-share-panel>
      </div>
    </section>
    <NavTab
      v-if="isShowNav"
      :dataInfo="{ ...moreInfoMsg, pics: baseInfoMsg.pics }"
      :statusHeight="statusHeight"
    ></NavTab>
  </header>
</template>

<script>
import Vue from 'vue'
import {
  defineComponent,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
  computed
} from '@vue/composition-api'
import { skipToUrl, pageClose, pageShare, isPlatform, waShare, showMoreDialog } from '@utils/native'
import { setShare, setWaShare } from '@utils/share.js'
import { Popup, SimpleDropdown, PlatformSharePanel, Toast } from '@zz-common/zz-ui'
import NavTab from '../../components/navTab/index'
import GuideSwiper from './guideSwiper.vue'
import { state } from '@/store/index'
import { getQueryString } from '@utils/index'
import { getLeaseJumpUrl } from '@/apis'

import { cookie, env } from '@zz-common/zz-utils'
import { login } from '@/lib/decorator/login'
import { useDecorator } from '@/lib/useDecorator'
Vue.use(Popup).use(SimpleDropdown).use(PlatformSharePanel)

export default defineComponent({
  components: {
    // Badge,
    NavTab,
    GuideSwiper,
    [PlatformSharePanel.name]: PlatformSharePanel
  },
  props: {
    statusHeight: {
      type: Number,
      default: 0
    },
    baseInfoMsg: {
      type: Object,
      default: () => {}
    },
    moreInfoMsg: {
      type: Object,
      default: () => {}
    },
    /**
     * $ 是否执行收藏数量动画
     */
    collectAnimationEnd: {
      type: Boolean,
      default: false
    },
    feedbackData: {
      type: Object,
      default: () => {}
    },
    /**
     * $ 是否执行购物车动画
     */
    cartAnimationEnd: {
      type: Boolean,
      default: false
    },
    carted: {
      type: Boolean,
      default: false
    }
  },
  setup(props, ctx) {
    const { $tiktok, $legoSend } = ctx.root
    $tiktok('created', 'Header')
    const transparent = ref(true)
    const showSwiper = ref(true)
    const inZZ = ref(false)
    const cartInfoCount = ref(0)
    const isShowMore = ref(false)
    const isShowNav = ref(false)

    const simpledropdown = ref(null)

    const activeInfo = ref(false)
    const wordActIndex = ref(0)

    /* eslint-disable */
    const collectAllCount = computed(() => {
      return state.initCollected
        ? props.collectAnimationEnd && state.collected
          ? limitCount(state.collectionCount)
          : limitCount(state.collectionCount - 1)
        : props.collectAnimationEnd && state.collected
        ? limitCount(state.collectionCount + 1)
        : limitCount(state.collectionCount)
    })
    /* eslint-enable */

    const keywordData = computed(() => {
      return props.baseInfoMsg?.singleWord || []
    })

    /**
     * $ 购物车数量 没有取消加入的操作 只需要 +1 即可
     */
    const cartedAllCount = computed(() => {
      return props.cartAnimationEnd && state.cartStatus
        ? limitCount(state.cartInfoNum)
        : limitCount(state.cartInfoNum)
    })

    /**
     * $ 商详类型 1-老B2C一机一拍 2-二奢一机一拍
     */
    // TODO: 二奢融合 商详类型
    const infoType = computed(() => {
      return props.baseInfoMsg?.infoType == 1000
    })

    // 是否展示租机入口按钮
    const showRentIcon = computed(() => {
      return props.baseInfoMsg?.infoType == 1000 && props.moreInfoMsg?.leaseVo?.topButton == 1
    })

    const useNativeFuction = computed(() => {
      const version = cookie.get('v')
      return inZZ.value && env.compareVersion(version, '10.10.0') > -1
    })

    const list = [
      {
        content: '消息',
        attrs: {
          'zz-sortid': 0,
          'zz-sortname': '消息',
          'zz-sectionid': 128
        }
      },
      {
        content: '分享',
        attrs: {
          'zz-sortid': 1,
          'zz-sortname': '分享',
          'zz-sectionid': 128
        }
      }
    ]

    const cartStatus = ref(false) // 购物车状态 是否执行购物车数量动画
    /**
     * $ 监听收藏动画结束 执行收藏数量动画
     */
    watch(
      () => props.collectAnimationEnd,
      (v) => {
        if (v) {
          activeInfo.value = true
        }
      }
    )

    /**
     * $ 监听加入购物车动画结束 执行购物车数量动画
     */
    watch(
      () => props.cartAnimationEnd,
      (v) => {
        if (v) {
          cartStatus.value = true
        }
      }
    )

    const platforms = ref({})
    const actions = ref([
      {
        value: 'feedback',
        title: '意见反馈',
        logo: '//pic3.zhuanstatic.com/zhuanzh/9c51f072-7563-4d65-a9a2-c2242f63eea4.png'
      }
    ]) // 更多按钮 操作数据
    const onPlatformSelect = (item, res) => {
      if (item.value == 'copy') return
      if (res?.code == 0) {
        Toast('分享成功')
      } else {
        Toast('分享失败，请检查是否安装了对应APP')
      }
    }

    /**
     * $ 点击操作
     * @param {*} action 操作类型
     */
    const onActionSelect = (action) => {
      if (action.value === 'sell') {
        toBm()
      } else if (action.value === 'feedback') {
        toFeedback()
      }
    }

    /**
     * $ 顶部角标数量
     */
    const limitCount = (num) => {
      if (Number.isNaN(num)) return 0
      return num > 99 ? '99+' : num
    }
    const onBack = () => {
      pageClose()
    }

    /**
     * $ 更多按钮点击
     */
    const onMoreClick = () => {
      isShowMore.value = !isShowMore.value
    }

    const onMoreItenClick = (url) => {
      skipToUrl({
        targetUrl: url
      })
    }

    /**
     * $ 转转app端内分享
     */
    const onShareClick = () => {
      const { shareTextTitle, shareTextContent, pics } = props.baseInfoMsg
      const shareInfo = setShare({ shareTextTitle, shareTextContent, pics })
      pageShare(shareInfo)
    }

    /**
     * $ 小程序内分享
     */
    const onWaShare = () => {
      const { shareTextTitle, shareTextContent, pics } = props.baseInfoMsg
      const shareInfo = setWaShare({ shareTextTitle, shareTextContent, pics })
      waShare(shareInfo)
    }

    /**
     * $ 实验（A 和 E）组和线上保持一致
     * $ 实验B组：(购物车 卖 租 更多) 仅购物车 （替换收藏按钮位置 顶部加一个购物车数量icon）
     * $ 实验C组：(收藏 购物车 租 更多) 同时有收藏、购物车 （底部替换搭售按钮，搭售按钮位置移动到立即购买按钮上方 顶部购物车位置替换卖，卖移动到更多里边 ）
     * $ 实验D组：(购物车 收藏 租 更多) 主购物车、次收藏 （替换收藏按钮 顶部加购物车数量icon，位置在第一个  第二个是收藏icon， 卖移动到更多里边）
     */
    onMounted(() => {
      document.addEventListener('click', () => {
        if (simpledropdown.value) {
          simpledropdown.value.triggerClose()
        }
      })
      $tiktok('mounted', 'Header')
      inZZ.value = isPlatform('zz')
      isShowNav.value = true
      document.addEventListener('scroll', monitorPageScroll, false)
    })

    watch(
      () => props.baseInfoMsg,
      (v) => {
        // TIPS: 二奢融合 拉齐  二奢第一行需要支持：微博的分享 第三行需要去掉：旧机换钱
        if (v && v.shareTextTitle && v.pics) {
          const { shareTextTitle, shareTextContent, pics } = v
          const data = {
            title: shareTextTitle,
            content: shareTextContent,
            imgUrl: `https:${pics[0]}`,
            jumpUrl: `${window.location.href}`
          }
          const res = {
            wechat: {
              value: 'wechat',
              title: '微信好友',
              scene: 'weixin-session',
              logo: 'ea37c0c6-e5ab-4e91-87dc-23e9654e4430.png',
              type: 'link',
              data
            },
            moments: {
              value: 'moments',
              title: '朋友圈',
              scene: 'weixin-timeline',
              logo: '8988caa5-fbec-4bd1-bf77-13d00295b1ee.png',
              type: 'link',
              data
            },
            qq: {
              value: 'qq',
              title: 'QQ',
              scene: 'qq-session',
              logo: '651472f0-2873-4352-931f-b2f3e77c63d9.png',
              type: 'link',
              data
            },
            qzone: false,
            weibo: false,
            copy: {
              value: 'copy',
              title: '复制链接',
              logo: '248b3f6e-eb20-47b4-a968-bdde110b9e1b.png',
              jumpUrl: `${window.location.href}`
            }
          }
          /* eslint-disable */
          platforms.value = {
            ...res,
            weibo:
              props.baseInfoMsg?.infoType != 1000
                ? {
                    value: 'weibo',
                    title: '微博',
                    scene: 'weibo',
                    logo: '9b49d2ed-82cc-4334-9d77-2917272b69a4.png',
                    type: 'link',
                    data
                  }
                : false
          }
        }
        /* eslint-enable */

        // TODO: 二奢融合 增加 是否是二奢商详的判断 手机才需要旧机换钱
        if (v && v.sellEntry && infoType.value) {
          const sellIndex = actions.value.findIndex((item) => item.value === 'sell')
          if (sellIndex === -1) {
            actions.value.unshift({
              value: 'sell',
              title: '旧机换钱',
              logo: '//pic2.zhuanstatic.com/zhuanzh/ba4f1c5c-af47-4f5d-840c-bb3f59dd6198.png'
            })
          }
        }
        if (props.baseInfoMsg?.pics) {
          if (isPlatform('wa')) {
            onWaShare()
          }
        }
      },
      { immediate: true }
    )

    const monitorPageScroll = () => {
      if (window.scrollY > 100) {
        transparent.value = false
        showSwiper.value = false
      } else {
        transparent.value = true
        showSwiper.value = true
      }
    }

    onBeforeUnmount(() => {
      document.removeEventListener('scroll', monitorPageScroll)
    })

    const handleDropdownClick = (index) => {
      $legoSend({
        pagetype: 'zpmclick',
        actiontype: 'T2974',
        backup: {
          sectionId: 99,
          sortId: index,
          sortName: index == 0 ? '消息' : '分享'
        }
      })
      if (index == 1) {
        onShareClick()
        return
      }
      const urlList = [
        'zhuanzhuan://jump/core/msgCenter/jump'
        // 'zhuanzhuan://jump/core/shoppingCartFavorites/jump?defaultPage=1&sourceType=5', // 此链接在9.15.9以后的版本已废弃
      ]
      onMoreItenClick(urlList[index])
    }

    const toCollect = () => {
      onMoreItenClick(
        'https://act.zhuanzhuan.com/platform/zz-platform-pages/my-collection?channel=b2cdetail&needHideHead=3'
      )
    }

    /**
     * $ 跳转购物车
     */
    const toCart = () => {
      const targetUrl =
        'https://m.zhuanzhuan.com/trade/shopping-car/index.html?source=&pageid=1879397717&cartAppType=0&needHideHead=1'
      skipToUrl({
        targetUrl
      })
    }

    /**
     * $ 收藏 or 取消收藏 加购物车 实验D组
     */
    const headerLike = () => {
      ctx.emit('listenLike')
    }

    const handleMoreClick = () => {
      const extend = encodeURIComponent(
        JSON.stringify({
          pageName: '商品详情',
          ...props.feedbackData
        })
      )
      console.log('extend', extend)
      showMoreDialog(
        {
          moreDialogData: {
            itemList: [
              {
                title: '消息',
                icon: 'https://pic2.zhuanstatic.com/zhuanzh/8dbf493c-1f88-46ac-8fb0-7ef47ba984b7.png',
                jumpUrl: 'zhuanzhuan://jump/core/msgCenter/jump'
              },
              // {
              //   title: '收藏夹',
              //   icon: 'https://pic6.zhuanstatic.com/zhuanzh/498de8ab-6bb4-4847-a785-b1a2fb993935.png',
              //   jumpUrl:
              //     'zhuanzhuan://jump/core/shoppingCartFavorites/jump?defaultPage=1&sourceType=b2cdetail',
              // },
              {
                title: '足迹',
                icon: 'https://pic3.zhuanstatic.com/zhuanzh/2acea7f5-6fb9-4d4f-be11-e927f00cdff6.png',
                jumpUrl: 'zhuanzhuan://jump/core/myFootPrints/jump?footFrom=b2cdetail'
              },
              {
                title: '购物车',
                icon: 'https://pic3.zhuanstatic.com/zhuanzh/30b806f5-8055-4824-b93e-6b7ead06beca.png',
                jumpUrl:
                  'https://m.zhuanzhuan.com/trade/shopping-car/index.html?pageid=1879397717&cartAppType=0&needHideHead=1&sourceType=b2cdetail#/home'
              },
              {
                title: '红包',
                icon: 'https://pic4.zhuanstatic.com/zhuanzh/2211cfe3-1056-4f8d-9b20-f518e70b3f71.png',
                jumpUrl: 'https://m.zhuanzhuan.com/trade/common_pages/envelope-list?needHideHead=3'
              },
              {
                title: '意见反馈',
                icon: 'https://pic3.zhuanstatic.com/zhuanzh/9c51f072-7563-4d65-a9a2-c2242f63eea4.png',
                jumpUrl: `https://m.zhuanzhuan.com/common/uem/index.html?needHideHead=3&hiddenProgress=1&wvCornerRadius=32&wvHalfVer=v2&wvHeightRate=0.8#/question-bch?questionnaireId=1647844439072183296&extend=${extend}`
              }
            ]
          },
          zpmPageId: 'T2974'
        },
        (res) => {
          console.log(res)
        }
      )
    }

    /**
     * $ 跳转 [卖]
     */
    const toBm = () => {
      const { sellEntry = '' } = props.baseInfoMsg
      skipToUrl({
        targetUrl: sellEntry
      })
    }

    /**
     * $ 意见反馈跳转
     */
    const toFeedback = () => {
      const extend = encodeURIComponent(
        JSON.stringify({
          pageName: '商品详情',
          ...props.feedbackData
        })
      )
      const targetUrl = `https://m.zhuanzhuan.com/common/uem/index.html?needHideHead=3&hiddenProgress=1&wvCornerRadius=32&wvHalfVer=v2&wvHeightRate=0.8#/question-bch?questionnaireId=1647844439072183296&extend=${extend}`
      skipToUrl({
        targetUrl
      })
    }

    let rentUrl = ''
    const toRent = useDecorator(async () => {
      if (!rentUrl) {
        // $ 查询租赁入口链接
        const infoId = getQueryString('infoId') || state.infoId
        if (!infoId || infoId === '') return // 如果infoId的值不存在，则直接返回
        const PPU = cookie.get('PPU')
        const zljToken = `PPU="${PPU}"`
        const data = await getLeaseJumpUrl({
          request: JSON.stringify({ productInfoId: infoId, inputTag: 2, zljToken })
        })
        rentUrl = data.data.jumpUrl
      }
      skipToUrl({
        targetUrl: rentUrl
      })
    }, login)

    const onSearch = () => {
      const targetUrl =
        decodeURIComponent(keywordData.value[wordActIndex.value].jumpUrl) +
        '&searchFromPageId=T2974'

      skipToUrl({
        targetUrl
      })
    }

    return {
      keywordData,
      wordActIndex,
      inZZ,
      cartInfoCount,
      isShowMore,
      onMoreItenClick,
      onBack,
      onShareClick,
      onMoreClick,
      transparent,
      showSwiper,
      isShowNav,
      simpledropdown,
      list,
      handleDropdownClick,
      handleMoreClick,
      useNativeFuction,
      toBm,
      toRent,
      state,
      getQueryString,
      onSearch,
      toCollect,
      limitCount,
      activeInfo,
      onPlatformSelect,
      platforms,
      collectAllCount,
      actions,
      onActionSelect,
      toCart,
      cartedAllCount, // 购物车数量
      cartStatus, // 加入购物车成功后 执行购物车数量动画
      headerLike,
      infoType, // 商详类型
      showRentIcon
    }
  }
})
</script>
